<template>
  <v-slider
    ref="slider"
    v-model="value"
    :min="min"
    :max="max"
    data-testid="slider"
    :step="step"
    @click.stop
  >
  </v-slider>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  export default defineComponent({
    props: {
      min: {
        type: Number,
        required: true,
      },
      max: {
        type: Number,
        required: true,
      },
      step: {
        type: Number,
        default: 1,
      },
      modelValue: {
        type: Number,
        default: null,
      },
    },
    emits: ["update:modelValue"],
    computed: {
      value: {
        get() {
          return this.modelValue
        },
        set(val: number) {
          return this.$emit("update:modelValue", val)
        },
      },
    },
  })
</script>

<style scoped>
  :deep(.v-input__details),
  :deep(.v-messages) {
    padding: 0px;
    min-height: 0px;
  }
</style>
